import { action } from "typesafe-actions";
import ActionTypes from "../../constants";

export const tapBtnIsCommercial = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_is_commercial",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const summaryEditClicked = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "tap_btn_vehicle_summary_edit",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const mobileNumberIsEntered = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "mobile_number_entered",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });

export const pincodeEntered = (customAttributes = {}) =>
  action(ActionTypes.TRACK, {
    event_name: "pincode_entered",
    customAttributes: {
      product_state: "Prequote",
      page: "prequote",
      ...customAttributes
    }
  });